


















import {
  Vue,
  Component,
} from "@/shared/vuepack";
import ContributionsProgressBar from "@/employee/components/shared/ContributionsProgressBar.vue";
import moment from "moment";
import {
  FundingOption
} from "@/shared/types";
import { useHsaTotalStore } from "@/shared/store/hsaTotal";
import { useUserStore } from "@/shared/store/user";
import { useHsaLimitStore } from "@/shared/store/hsalimit";
import { useHsaStore } from "@/shared/store/hsa";

@Component({
  components: {
    ContributionsProgressBar
  }
})
export default class ReadOnlyContributions extends Vue {

  userStore = useUserStore();
  hsaLimitStore = useHsaLimitStore();
  hsaTotalStore = useHsaTotalStore();
  hsaStore = useHsaStore();

  activePayrollYear = moment().year();

  get hsaLimit () {
    return this.hsaLimitStore.getHsaLimitByYear(moment().year());
  }

  get employerTotal (): number {
    if (this.userStore.employeeFundingOption === FundingOption.BendCalculatePull) {
      return this.hsaTotalStore.employerAmount;
    }
    return this.hsaStore.totalEmployerPayrollContributions(this.activePayrollYear);
  }

  get employeePersonalContributions () {
    return this.hsaStore.totalEmployeePersonalContributions() + this.projectedPersonalScheduledContributions;
  }

  get employeeContributionsTotal (): number {
    if (this.userStore.employeeFundingOption === FundingOption.BendCalculatePull) {
      return this.totalEmployeePayrollContributions +
          this.employeePersonalContributions + this.hsaStore.bankDirectContributions(this.activePayrollYear);
    }
    return this.hsaStore.employeePreTaxContributions(this.activePayrollYear)
        + this.employeePersonalContributions
        + this.hsaStore.bankDirectContributions(this.activePayrollYear)
        + this.hsaStore.employeePostTaxContributions(this.activePayrollYear);
  }

  get projectedPersonalScheduledContributions (): number {
    return this.hsaTotalStore.personalScheduledContributionsByYear(moment().year(), true);
  }

  get totalEmployeePayrollContributions (): number {
    return this.totalEmployeePreTaxPayrollContributions;
  }

  get totalEmployeePreTaxPayrollContributions (): number {
    return this.hsaTotalStore.initialAnnualPreTaxContribution;
  }

  get otherHsaAmount () {
    return this.hsaLimitStore.otherHsaAmount();
  }
}
